import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import type { AssistantActionStatus } from '~/data/api/client/assistant/enhancedEndpoints'

// eslint-disable-next-line import/prefer-default-export
export function useAssistantActionStatusFormatter() {
  const t = useTranslations('data.assistant')

  return useCallback(
    (status: AssistantActionStatus): string => {
      switch (status) {
        case 'proposed':
          return t('actionStatus_proposed')
        case 'queued':
          return t('actionStatus_queued')
        case 'running':
          return t('actionStatus_running')
        case 'done':
          return t('actionStatus_done')
        case 'failed':
          return t('actionStatus_failed')
        case 'rejected':
          return t('actionStatus_rejected')
        default: {
          const unreachable: never = status
          return unreachable
        }
      }
    },
    [t]
  )
}
